import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';

function SelectMenu({ children, title = 'Actions' }) {
  return (
    <Menu as="div" className="relative inline-block">
      <div>
        <MenuButton className="group inline-flex w-full justify-center gap-x-1.5 rounded-md bg-rcprimary-400 px-3 py-1.5 font-medium text-sm text-white outline-2 outline-solid outline-white/0 outline-offset-0 hover:bg-rcprimary-400/0 hover:text-rcprimary-400 hover:outline-rcprimary-400">
          {title}
          <ChevronDownIcon
            className="-mr-1 size-5 text-white group-hover:text-rcprimary-400"
            aria-hidden="true"
          />
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 max-h-[70vh] w-80 origin-top-right divide-y divide-white/15 overflow-y-auto rounded-md bg-gray-800 shadow-lg outline-1 outline-black/5 -outline-offset-1 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-leave:duration-75 data-enter:ease-out data-leave:ease-in"
      >
        {children}
      </MenuItems>
    </Menu>
  );
}

SelectMenu.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default SelectMenu;
